export default __webpack_public_path__ + "static/media/bump.9c4b407b.webp";